<template>
  <div>
    <div v-for="(item, indexProgram) in listProgram" :key="indexProgram + 'program'" class="d-column" >
      <div class="h-profile no h-profile-lg d-flex flex-column pb-3 align-items-start" >
        <div class="d-flex align-self-start d-flex flex-column align-items-start w-100 mb-2" >
          <div class="v-line-full"><span></span></div>
          <div class="d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100 z-fix" >
            <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.avatar" type="image/png" style="background-color: #fff;" >
              <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../assets/images/default.png" alt="Avatar" />
            </object>
            <div class="d-flex w-100">
              <div class="align-self-start mt-1 w-100">
                <h3 class="pb-1" v-if="item._id">
                  <router-link :to="'/program/detail?' + item._id" class="link-block" >
                    <strong v-text="item.name"></strong>
                  </router-link>
                </h3>
                <h3 class="pb-1" v-else>
                  <strong v-text="item.name"></strong>
                </h3>
                <div class="my-2">
                  <a class="badge badge-warning text-white" v-if="item.status == 'pending'" v-text="$ml.get('pending')" >Pendente</a>
                  <a class="badge badge-secondary text-white" v-show="item.status == 'paused'" v-text="$ml.get('paused')" >Pausado</a>
                  <a class="badge badge-success" v-show="item.status == 'closed'" v-text="$ml.get('closed')" >Encerrado</a>
                </div>

                <p class="d-flex align-items-center pb-2">
                  <span class="align-self-center" v-text=" $ml.with($utils.formatData(item.createdAt, $ml.get('ln'))).get('publishedDaysAgo') " >
                  </span>
                </p>
                
                <div class="actions mt-2 d-flex flex-row">
                  <VueCustomTooltip :label="$ml.get('ccpProgPriv')">
                    <span v-if="item.type == 'private'" class="ico ico-locked mr-1" >
                      <img src="../../../src/assets/icons/lock.svg" class="ico-13" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('ccpProgPubli')">
                    <span v-show="item.type == 'public'" class="ico ico-locked mr-1" >
                      <img src="../../../src/assets/icons/unlock.svg" class="ico-13" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('managedProgram')">
                    <span v-if="item.managed" class="ico ico-managed">
                      <img src="../../assets/images/bughunt.svg" />
                    </span>
                  </VueCustomTooltip>
                  <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                    <span v-if="item.program_nda" class="ico ico-nda">
                      <img src="../../assets/icons/security-shield.svg" />
                    </span>
                  </VueCustomTooltip>
                </div>
                <hr />
                <div class="card-chart-body card-chart-body-lg w-100">
                  <div class="row">
                    <div class="col-8 col-md-4 border-r-d mt-2 mb-2">
                      <span class="pb-1" v-text="$ml.get('specialist')" >Especialistas</span >
                      <h6>{{ item.totalHackers }}</h6>
                    </div>
                    <div class="col-8 col-md-4 border-r-d pl-3 mt-2 mb-2">
                      <span class="pb-1" v-text="$ml.get('reports')" >Relatórios</span >
                      <h6>{{ item.totalReports }}</h6>
                    </div>

                    <div class="col-8 row d-none d-md-flex">
                      <div class="col-12 border-r-d pl-3 mt-2 mb-2">
                        <span class="pb-1" v-text="$ml.get('resolved')" >Resolvidos</span >
                        <h6>{{ item.totalClosedReports }}</h6>
                      </div>
                      <div class="col-12 border-r-d pl-3 mt-2 mb-2">
                        <span class="pb-1" v-text="$ml.get('scope')" >Escopo</span >
                        <h6>{{ item.totalScopes }}</h6>
                      </div>
                    </div>

                    <div class="col-8 col-md-4 pl-3 mt-2 mb-2">
                      <span class="pb-1" v-text="$ml.get('rewards')" >Recompensas</span >
                      <div class="row">
                        <span class="pr-2 d-flex align-items-center" v-if="item.offersBounty" >
                          <img src="../../../src/assets/icons/dollar-sign.svg" class="ico-13 mr-1" />
                          <font v-text="$ml.get('money')">Dinheiro</font>
                        </span>
                        <span class="d-flex align-items-center" v-if="item.offersGift" >
                          <img src="../../../src/assets/icons/gift.svg" class="ico-13 mr-1" />
                          <font v-text="$ml.get('gift')">Brinde</font>
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-for="(report, indexReport) in item.reports" :key="indexReport + 'reports'" >
          <div v-if="indexReport < 5" class="d-flex align-self-start h-profile-circle" >
            <div class="circle d-flex justify-content-center">
              <!-- <span class="circle-internal d-flex justify-content-center" ><span class="circle-success"></span ></span> -->
              <span class="circle-internal d-flex justify-content-center">
                <span :class="'circle-pending ' + report.status"></span>
              </span>
              <div class="h-line"><span></span></div>
            </div>
            <div class="pl-3 d-flex w-100 align-items-center">
              <router-link :to="'/report/details?' + report._id" class="d-flex flex-row align-items-start w-100 pointer" >
                <a :class=" 'badge badge-warning mr-2 align-self-start ' + report.status " >#{{ report._id }}</a >
                <Impact :impact="'impact-' + report.severity" class="mt-1 mr-1" />
                <h6 class="align-self-center">
                  <a class="link-block" v-text="report.title"></a>
                </h6>
              </router-link>
            </div>
          </div>
          <div v-if="indexReport == 5" class="d-flex align-self-start h-profile-circle" >
            <div class="circle d-flex justify-content-center">
              <div class="h-line"><span></span></div>
            </div>
            <div class="pl-3 d-flex w-100 align-items-center">
              <div class="d-flex flex-row align-items-start w-100 pointer">
                <span class="badge  mr-2 align-self-start">. . .</span>
              </div>
            </div>
          </div>

          <div class="d-flex align-self-start h-profile">
            <div class="v-line d-flex align-items-stretch">
              <span class="pb-4"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listProgram: {
      type: Array,
      required: false,
    },
  },
};
</script>
<style scoped>
.closed {
  background-color: #28a745 !important;
  color: #fff;
  background-color: #28a745;
}
</style>
